import { autoinject } from "aurelia-dependency-injection";
import {computedFrom} from "aurelia-framework";
import { type VesselComparisonSocialDetails } from "../../../../../models/vessel-comparison/vessel-comparison.models";

@autoinject()
export class VesselComparisonSocialVm {
    //Any type until social model is finalised and created
    private _vesselSocialVesselDetails: VesselComparisonSocialDetails;
    isSanctioned: boolean;
    isFlagFake: boolean;

    @computedFrom("_vesselSocialVesselDetails")
    get vesselSocialVesselDetails(): VesselComparisonSocialDetails {
        return this._vesselSocialVesselDetails;
    }

    set vesselSocialVesselDetails(value: VesselComparisonSocialDetails) {
        this._vesselSocialVesselDetails = value;
    }

    @computedFrom("isSanctioned", "_vesselSocialVesselDetails")
    get showLink() {
        let result = true;

        if(this.isSanctioned || this.isFlagFake)
            result = false;

        return result;
    }

    constructor(vesselSocialVesselDetails: VesselComparisonSocialDetails, isSanctioned: boolean, isFlagFake: boolean) {
        this.vesselSocialVesselDetails = vesselSocialVesselDetails;
        this.isSanctioned = isSanctioned;
        this.isFlagFake = isFlagFake;
    }
}